export function isDesignerOnline(designer: any) {
    return Math.round((Date.now() - Date.parse(designer.profile.lastSeenAt)) / (60 * 1000)) <= 20;
}
